import { FormulaErrorTypes, makeErrorRecord } from 'automation-ui-formula-editor/formula-editor/grammar/constants/ErrorTypes';
import { expressionToList } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
const makeParseResult = ({
  parsedExpression = {},
  validationErrors = [],
  syntaxErrors = []
}) => {
  return {
    parsedExpression: parsedExpression,
    validationErrors,
    syntaxErrors
  };
};
const parseWithErrors = ({
  parse,
  input,
  validate,
  expressionMode
}) => {
  try {
    const parsedExpression = parse(input);
    const validationErrors = validate && validate(parsedExpression);
    const parsedSyntaxErrorsList = expressionToList(parsedExpression).map(expression => {
      if (expression.syntaxError && FormulaErrorTypes[expression.syntaxError]) {
        return makeErrorRecord({
          type: FormulaErrorTypes[expression.syntaxError],
          context: expression
        });
      }
      return null;
    }).filter(error => !!error);
    if (parsedSyntaxErrorsList.length && expressionMode && expressionMode.getSyntaxError) {
      return makeParseResult({
        parsedExpression,
        validationErrors: [],
        syntaxErrors: [makeErrorRecord({
          type: FormulaErrorTypes.SYNTAX_GENERAL,
          context: {
            message: expressionMode.getSyntaxError()
          }
        })]
      });
    }
    return makeParseResult({
      parsedExpression,
      validationErrors,
      syntaxErrors: parsedSyntaxErrorsList
    });
  } catch (error) {
    // Since this function swallows errors, display the uncommon ones in the console

    // @ts-expect-error typing error in catch not supported
    if (error.name !== 'SyntaxError') {
      console.error(error);
    }
    if (input === '') {
      return makeParseResult({
        parsedExpression: {}
      });
    }

    /* expression mode special syntax error message */
    if (expressionMode && expressionMode.getSyntaxError) {
      return makeParseResult({
        parsedExpression: null,
        validationErrors: [],
        syntaxErrors: [makeErrorRecord({
          type: FormulaErrorTypes.SYNTAX_GENERAL,
          context: {
            message: expressionMode.getSyntaxError()
          }
        })]
      });
    }

    /* Specific syntax error */
    // @ts-expect-error typing error in catch not supported
    if (error.name === 'SyntaxError') {
      return makeParseResult({
        parsedExpression: null,
        validationErrors: [],
        syntaxErrors: [makeErrorRecord({
          type: FormulaErrorTypes.SYNTAX_SPECIFIC,
          context: {
            // @ts-expect-error typing error in catch not supported
            found: error.found,
            // @ts-expect-error typing error in catch not supported
            location: error.location
          }
        })]
      });
    }

    /* General default syntax error*/
    return makeParseResult({
      parsedExpression: null,
      validationErrors: [],
      syntaxErrors: [makeErrorRecord({
        type: FormulaErrorTypes.SYNTAX_GENERAL
      })]
    });
  }
};
export default parseWithErrors;